import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-pdialog-wrapper',
    templateUrl: './pdialog-wrapper.component.html',
    styleUrls: ['./pdialog-wrapper.component.scss'],
    standalone: false
})
export class PDialogWrapperComponent {
    @Input() header: string = '';
    @Input() visible: boolean = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Input() modal: boolean = true;
    @Input() styleClass: string = '';
    @Input() contentStyleClass: { [key: string]: string } = { width: '60vw' };
    @Input() breakpoints: { [key: string]: string } = {
        '575px': '90vw',
        '767px': '75vw',
        '1024px': '75vw',
        '1120px': '70vw',
        '2400px': '60vw',
    };

    @Input() blockScroll: boolean = true;
    @Input() closeOnEscape: boolean = false;
    @Input() closable: boolean = true;
    @Input() appendTo: 'body' | HTMLElement = 'body';
    onDialogHide() {
        this.visibleChange.emit(false);
    }
}
